export default {"src":"/_next/static/media/0x0a5e677a6a24b2f1a2bf4f3bffc443231d2fdec8.e0a56871.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};